import type { HelpFile } from '../../types/help'
import { TargetSystemsResourcesTestIds } from '../../../testids/TargetSystemsResourcesTestIds'

export const targetSystemsResourcesHelp: HelpFile = {
  docPage: '/docs/systems/overview',
  texts: {
    [TargetSystemsResourcesTestIds.targetSystemsResourcesWelcomeCard]:
      'Target Systems landing page — pick a tool from the sidebar: target systems, resources, and enforcement objects.',
  },
}
